let host = ''
    , userId = ''
    , userClass = ''
    , source = ''
    , implementationId = ''
    , adProvider = ''

let exports = {
    sendEvent(event, value = '', referrer = '') {
        new Image().src = `//imp.${host}/impression.do?event=${event}&page=${value}&referrer=${referrer}&user_id=${userId}&source=${source}&traffic_source=${adProvider}&subid=${userClass}&implementation_id=${implementationId}`;
    }
};

export default {
    install (Vue, options) {
        Vue.prototype.$impressions = exports;
        Vue.$impressions = exports;

        host = options.host;
        userId = options.userId;
        userClass = options.userClass;
        source = options.source;
        implementationId = options.implementationId;
        adProvider = options.adProvider;
    }
}